import { useContext } from 'react';
import {UserContext} from '../contexts/UserContext'; // Replace with the actual path to your context

const useDecodedUser = () => {
  const { decodedUser } = useContext(UserContext); // Assuming your context provides a `user` object
  return decodedUser;
};

export default useDecodedUser;


// //****************************************************************** */
// // services/hooks/useDecodedUser.js
// import { useState, useEffect } from 'react';
// import { jwtDecode } from 'jwt-decode';

// const useDecodedUser = () => {
//   const [decodedUser, setDecodedUser] = useState(null);

//   useEffect(() => {
//     const token = sessionStorage.getItem('token');
//     console.log("🔍 useDecodedUser: Token from sessionStorage:", token ? "Exists" : "Null");
    
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         console.log("🔍 useDecodedUser: Successfully decoded user:", decoded);
//         setDecodedUser(decoded);
//       } catch (error) {
//         console.error('❌ useDecodedUser: Error decoding token:', error);
//         sessionStorage.removeItem('token');
//         sessionStorage.removeItem('user-id');
//         setDecodedUser(null);
//       }
//     } else {
//       console.log("🔍 useDecodedUser: No token found");
//       setDecodedUser(null);
//     }
//   }, []);

//   return decodedUser;
// };

// export default useDecodedUser;

// //***************************************************************** */